<template>

    <v-app style="overflow:hidden;">

        <v-dialog
            v-model="queue_enable"
            persistent
            outlined
        >
            <v-card class="py-16 text-h6">
                <div><v-icon class="py-12 text-h1">mdi-close-circle</v-icon></div>
                <div>จุดบริการยังไม่เปิดให้บริการ</div>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog_newqueue"
            fullscreen
            hide-overlay
        >
            <v-card style="overflow-x: hidden;">

                    <v-btn class="mr-4" icon @click="dialog_newqueue = false" style="display: block;margin-left:auto;">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                <div>
                    <v-row>
                        <v-col cols="5">
                            <v-img :src="logo" contain class="pa-4" style="margin-left: auto;border-radius: 50%;border-color: rgb(220, 223, 240);border-style: solid;max-width: 72px;" />
                        </v-col>
                        <v-col cols="7" style="align-self: center">
                            <div class="px-8 py-1 align-self-center" style="border-color: rgb(98, 194, 208);border-style: solid;border-radius: 25px;width:max-content">
                                <b>{{ station_name }}</b>
                            </div>
                        </v-col>
                    </v-row>
                </div>
                <div class="text-h4 mt-16"><b>เลือกบริการ</b></div>
                <v-list class="text-h6">
                    <v-list-item
                        align="center"
                        v-for="(item) in queuegroup"
                        :key="item.queue_group_id"
                    >
                        <v-list-item-content>
                            <v-btn class="mb-n3 text-h6" 
                            elevation="0"
                            x-large
                            outlined
                            :disabled="!item.enable"
                            :style="'display:block;border-style: solid;border-radius: 10px;border-width: 2px;'
                            + (item.enable ? 'color: black !important;border-color: rgb(98, 194, 208)!important;' : 'color: darkgrey !important;background-color: lightgray;border-color: darkgery !important;')"
                            color="primary" width="80%" @click="cmd('gen' + item.queue_group_id)">
                                <div>
                                    <div>{{ item.queue_group_name }}</div>
                                    <div class="text-caption" v-if="!item.enable" style="color:red">{{ item.is_enable == 0 ? "*บริการไม่เปิดให้รับคิว" : "*กรุณายกเลิกคิวเดิมก่อนทำการขอคิวใหม่" }}</div>
                                </div>
                            </v-btn>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog_cancelqueue"
            fullscreen
            hide-overlay
        >
            <v-card>
                <div style="color: white;">delete queue</div>
                <div class="mx-12 mt-12 py-2" style="border-style: solid;border-radius: 25px;overflow: hidden;border-color: rgb(97, 192, 212);">
                    <div class="text-h5">{{ cancelqueue.queue_group }}</div>
                    <div class="text-h2"><b>{{ cancelqueue.queue_number }}</b></div>
                </div>
                <div class="mt-8 text-h4"><b>"ยินยันการยกเลิกคิว"</b></div>
                <div class="mt-1 text-h5">คุณจะไม่ได้รับบริการในคิวนี้</div>
                <div class="mt-8 text-h4"><b>Delete your Queue</b></div>
                <div class="mt-1 text-h6">
                    <div>Your queue number will no longer</div>
                    <div>available in this service group.</div>
                </div>
                <div class="mt-12 d-inline-flex justify-center">
                    <v-btn 
                        rounded
                        large
                        class="mr-4 text-h5" 
                        style="border-color: #787878;background-color: white;border-width: 1px;border-style: solid;" 
                        @click="dialog_cancelqueue = false"
                    > 
                        อยู่ในคิวต่อ
                    </v-btn>
                    <v-btn 
                        rounded
                        large 
                        class="ml-4 text-h5" 
                        style="border-color: rgb(252, 2, 4);background-color: rgb(252, 2, 4);color:white;" 
                        @click="cmd('cancel',cancelqueue.queue_id + ',' + cancelqueue.queue_round)"
                    > 
                        ยกเลิกคิว
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>

        <div class="pa-3 d-flex justify-center align-center" style="background-color: rgb(81, 120, 251);color:white;">
            <v-img class="mr-4" :src="require('@/assets/9manat-line-logo-01.png')" contain style="max-width:40px" />
            9 ma-nad
        </div>

        <div>
            <v-row>
                <v-col cols="5">
                    <v-img :src="logo" contain class="pa-4" style="margin-left: auto;border-radius: 50%;border-color: rgb(220, 223, 240);border-style: solid;max-width: 72px;" />
                </v-col>
                <v-col cols="7" style="align-self: center">
                    <div class="px-8 py-1 align-self-center" style="border-color: rgb(98, 194, 208);border-style: solid;border-radius: 25px;width:max-content">
                        <b>{{ station_name }}</b>
                    </div>
                </v-col>
            </v-row>
        </div>

        <div 
            class="px-8 py-1" 
            style="
                border-color: rgb(98, 194, 208);
                border-style: solid;
                border-radius: 25px;
                overflow: hidden;
            "
            v-if="queue_announcement.length>0"
        >
            <div id="div_queue_announcement" 
                :style="cssVars"
            >
                {{ queue_announcement }}
            </div>
            
        </div>


        <v-list :style="'overflow:scroll;' + (queue_announcement.length>0 ? 'height:55%;' : 'height:60%;' )">
            <v-list-item
                v-for="(item) in queuelist"
                :key="item.id"
                style="display:block;padding:0;"
            >
                <div class="ma-4 mt-6 mx-8">
                    <v-btn 
                        rounded 
                        class="mt-n5" 
                        style="position:absolute;right:4%;border-color: rgb(252, 2, 4);background-color: rgb(252, 2, 4);color:white;" 
                        v-if="item.queue_status_id == 1"
                        @click="dialog_cancelqueue = true;cancelqueue=item"
                    > 
                        ยกเลิกคิว <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <div :style="'border-style: solid;border-radius: 25px;overflow: hidden;'
                            + (item.id==2 ? 'border-color: rgb(172, 77, 111);'
                            : (item.id==1 ? 'border-color: rgb(80, 144, 208);' 
                            : 'border-color: rgb(97, 192, 212);'))">
                        <div class="pa-1"><b>{{ item.queue_group }}</b></div>
                        <v-row class="mb-n3" v-if="item.queue_status_id == 1">
                            <v-col cols="5" style="color:grey">
                                <div v-if="item.queue_calling_number.length > 0">กำลังเรียกคิว</div>
                                <div class="text-h3">{{ item.queue_calling_number }}</div>
                                <div class="text-body-2" style="align-items: center;display: inline-flex;">
                                    <div>จำนวนรอ</div>
                                    <div><b class="text-h4" :style="
                                        item.id==2 ? 'color: rgb(172, 77, 111);'
                                        : (item.id==1 ? 'color: rgb(80, 144, 208);' 
                                        : 'color: rgb(97, 192, 212);')
                                    ">></b></div>
                                    <div>{{ item.queue_count_wait }}</div>
                                </div>
                            </v-col>
                            <v-col cols="7" :style="
                                    item.id==2 ? 'background-color: rgb(172, 77, 111);'
                                    : (item.id==1 ? 'background-color: rgb(80, 144, 208);' 
                                    : 'background-color: rgb(97, 192, 212);')
                                ">
                                <div>คิวของคุณ</div>
                                <div class="text-h2"><b>{{item.queue_number}}</b></div>
                            </v-col>
                        </v-row>
                        <div :class="'mb-n3 pt-2 ' + (item.id==2 ? 'calling2' : (item.id==1 ? 'calling1' : 'calling0')) " 
                        v-if="item.queue_status_id == 2">
                            <div>กำลังเรียกคิวของคุณ</div>
                            <div class="text-h1"><b>{{item.queue_number}}</b></div>
                        </div>
                        <v-col :style="
                                    item.id==2 ? 'background-color: rgb(172, 77, 111);'
                                    : (item.id==1 ? 'background-color: rgb(80, 144, 208);' 
                                    : 'background-color: rgb(97, 192, 212);')
                                " v-if="item.queue_status_id == 3">
                                <div>สิ้นสุดการให้บริการคิว {{item.queue_number}} ของคุณ</div>
                        </v-col>

                    </div>
                </div>
            </v-list-item>
        </v-list>

        
        <div align="center" style="position:fixed;bottom: 2%;width:100%;">
            <v-btn rounded style="color:white;background-color: rgb(79, 199, 224);"  width="20%" @click="dialog_newqueue = true">
                คิวใหม่
          </v-btn>
        </div>
         
    </v-app>
</template>

<style>
html {
    height: 100%;
    
}
body {
    height: 100%;
}
#app {
    height: 100%;
    font-family: SukhumvitSet !important
}
.v-application .text-h2,.v-application .text-h5,.v-application .text-h3,.v-application .text-h1, .v-application .text-h4,.v-application .text-h6,.v-application .text-body-2,.v-application .text-caption{
    font-family: SukhumvitSet !important
}

@keyframes scrollText {
    0%  {
        -webkit-transform: translateX(var(--announcement_2));
        -moz-transform: translateX(var(--announcement_2));
        -o-transform: translateX(var(--announcement_2));
        transform: translateX(var(--announcement_2));
        visibility: visible;
    }
    0.1%  {
        -webkit-transform: translateX(var(--announcement_2));
        -moz-transform: translateX(var(--announcement_2));
        -o-transform: translateX(var(--announcement_2));
        transform: translateX(var(--announcement_2));
        visibility: hidden;
    }
    0.2%  {
        -webkit-transform: translateX(var(--announcement_3));
        -moz-transform: translateX(var(--announcement_3));
        -o-transform: translateX(var(--announcement_3));
        transform: translateX(var(--announcement_3));
        visibility: hidden;
    }
    0.3%  {
        -webkit-transform: translateX(var(--announcement_3));
        -moz-transform: translateX(var(--announcement_3));
        -o-transform: translateX(var(--announcement_3));
        transform: translateX(var(--announcement_3));
        visibility: visible;
    }
    100% {
        -webkit-transform: translateX(var(--announcement_2));
        -moz-transform: translateX(var(--announcement_2));
        -o-transform: translateX(var(--announcement_2));
        transform: translateX(var(--announcement_2));
        visibility: visible;
    }
}

.calling0 {
  -webkit-animation: CALLING0-ANIMATION 1s infinite;  /* Safari 4+ */
  -moz-animation: CALLING0-ANIMATION 1s infinite;  /* Fx 5+ */
  -o-animation: CALLING0-ANIMATION 1s infinite;  /* Opera 12+ */
  animation: CALLING0-ANIMATION 1s infinite;  /* IE 10+, Fx 29+ */
}

@-webkit-keyframes CALLING0-ANIMATION {
  0%, 49% {
    background-color: rgb(97, 192, 212);
  }
  50%, 100% {
    background-color: rgb(62, 120, 140);
  }
}

.calling1 {
  -webkit-animation: CALLING1-ANIMATION 1s infinite;  /* Safari 4+ */
  -moz-animation: CALLING1-ANIMATION 1s infinite;  /* Fx 5+ */
  -o-animation: CALLING1-ANIMATION 1s infinite;  /* Opera 12+ */
  animation: CALLING1-ANIMATION 1s infinite;  /* IE 10+, Fx 29+ */
}

@-webkit-keyframes CALLING1-ANIMATION {
  0%, 49% {
    background-color: rgb(80, 144, 208);
  }
  50%, 100% {
    background-color: rgb(50, 90, 140);
  }
}

.calling2 {
  -webkit-animation: CALLING2-ANIMATION 1s infinite;  /* Safari 4+ */
  -moz-animation: CALLING2-ANIMATION 1s infinite;  /* Fx 5+ */
  -o-animation: CALLING2-ANIMATION 1s infinite;  /* Opera 12+ */
  animation: CALLING2-ANIMATION 1s infinite;  /* IE 10+, Fx 29+ */
}

@-webkit-keyframes CALLING2-ANIMATION {
  0%, 49% {
    background-color: rgb(172, 77, 111);
  }
  50%, 100% {
    background-color: rgb(130, 50, 70);
  }
}

</style>

<script>

import axios from 'axios';
import config from '@/../config.js'
import Member from '@/models/instance/Member'

export default {
  data () {
    return {
        dialog_newqueue : false
        ,dialog_cancelqueue : false
        ,cancelqueue : {}
        ,queuegroup : []
        ,isHaveQueue : false,

        queuelist : []

        ,station_name : ""
        ,logo: require('@/assets/logo-default.jpg')
        ,queue_enable : false
        ,queue_announcement : "announcement announcement announcement announcement announcement"
        ,queue_announcement_time : 20

        ,cssVars : {'width' : 'fit-content','white-space' : 'nowrap'}
    }
  },
  mounted : function () {
      this.reload()
      const self = this
      setInterval(function() {
          self.reload(false)
      },1000*30)
  },
  methods : {
    reload(backgroud=true){
        if(backgroud){
            var que = this.$store.commit('addLoading')
        }
        axios
        .post(config.api.url.public.queue.get_stationdetail
            ,{station_code:this.$route.params.station_code}
        ).then(response_stationdetail => {

            this.station_name = response_stationdetail.data.station_name
            if(response_stationdetail.data.logo.length>0) this.logo = response_stationdetail.data.logo
            this.queue_enable = !(response_stationdetail.data.queue_enable == 'true')
            this.queue_announcement = response_stationdetail.data.queue_announcement

            if(this.queue_announcement.length>0){
                if((document.getElementById('div_queue_announcement').offsetWidth > document.getElementById('app').offsetWidth)){
                    this.cssVars['animation'] = 'scrollText ' + ((document.getElementById('div_queue_announcement').offsetWidth / document.getElementById('app').offsetWidth) * 15) + 's infinite linear'
                    this.cssVars['--announcement_2'] = '-' + (document.getElementById('div_queue_announcement').offsetWidth + 24) + 'px'
                    this.cssVars['--announcement_3'] = (document.getElementById('app').offsetWidth + 24) + 'px'
                }else{
                    this.cssVars['animation'] = 'scrollText 1s'
                    this.cssVars['--announcement_2'] = '0%'
                    this.cssVars['--announcement_3'] = '0%'
                }
            }
            
            

            axios
            .post(config.api.url.public.queue.get_queuegroup
                ,{station_code:this.$route.params.station_code}
            ).then(response_queuegroup => {

                this.queuegroup = response_queuegroup.data

                axios
                .post(config.api.url.line.queue.get_lastqueue
                    ,{station_code:this.$route.params.station_code}
                    ,{ headers: Member.getTokenHeader()}
                )
                .then(response => {
                    
                    this.length = response.data.length
                    this.isHaveQueue = response.data.length > 0
                    this.queuelist = response.data

                    this.queuegroup.forEach((c,j)=>{
                        this.queuegroup[j].enable = (c.is_enable == 1)
                    })

                    this.queuelist.forEach((q,i)=>{

                        q.queue_group = q.queue_group.split('=')
                        this.queuelist[i].queue_group_id = q.queue_group[0]
                        this.queuegroup.forEach(g=>{
                            if(g.queue_group_id==q.queue_group[0]){
                                this.queuelist[i].queue_group = g.queue_group_name
                            }
                        })

                        if(q.queue_status_id == 1){
                            this.queuelist[i].queue_status = "Waiting"
                            this.queuelist[i].queue_status_th = "รอเรียกคิว"
                            this.queuelist[i].queue_status_extra1 = "Queue(s) ahead"
                            this.queuelist[i].queue_status_extra1_th = "รออีก"
                            this.queuelist[i].queue_status_extra2 = q.queue_count_wait + (q.queue_calling_number != null ? " Queue (Calling " + q.queue_calling_number + ')' : "")
                            this.queuelist[i].queue_status_extra2_th = q.queue_count_wait + (q.queue_calling_number != null ? " คิว (กำลังเรียก " + q.queue_calling_number + ')' : "")
                            this.queuegroup.forEach((c,j)=>{
                                if(c.queue_group_id == this.queuelist[i].queue_group_id){
                                    this.queuegroup[j].enable = false
                                }
                            })
                        }else if(q.queue_status_id == 2){
                            this.queuelist[i].queue_status = "Calling"
                            this.queuelist[i].queue_status_th = "กำลังเรียกคิว"
                            this.queuelist[i].queue_status_extra1 = "Please contact"
                            this.queuelist[i].queue_status_extra1_th = "กรุณารับบริการ"
                            this.queuelist[i].queue_status_extra2 = "Counter " + q.queue_calling_by
                            this.queuelist[i].queue_status_extra2_th = "ที่ช่องบริการ " + q.queue_calling_by
                        }else if(q.queue_status_id == 3){
                            this.queuelist[i].queue_status = "Finished"
                            this.queuelist[i].queue_status_th = "สิ้นสุดการให้บริการ"
                        }
                    })

                    var tmpqueuelist = [...this.queuelist]
                    this.queuelist = []
                    this.queuegroup.forEach((c)=>{
                        tmpqueuelist.forEach((q)=>{
                            if(c.queue_group_id == q.queue_group_id){
                                this.queuelist.push(q)
                            }
                        })
                    })
                    this.queuelist.forEach((q,i)=>{
                        this.queuelist[i].id = i
                    })

                    if(backgroud){
                        this.$store.commit('finishLoading',que)
                    }


                    if(backgroud){
                        this.$store.commit('finishLoading',que)
                    }
                })
            })
        })
    },
    cmd(id,param=null){
        this.dialog_newqueue = false
        this.dialog_cancelqueue = false
        //console.log(id)
        var pdata = {
            station_code:this.$route.params.station_code
            ,cmdid:id
        }
        if(param != null){
            pdata['param'] = param
        }

        var que = this.$store.commit('addLoading')
        axios
            .post(config.api.url.line.queue.add_cmd
            ,pdata
            ,{ headers: Member.getTokenHeader()}
        )
            .then(response => {
            this.$store.commit('finishLoading',que)
            console.log(response.data)
            if(response.data.isSuccess){
                this.reload()
            }
        })
    }
  }
}
</script>